import { parse } from 'graphql'

export interface MarketplaceSavedDevice {
  id: string
  companyId: number
  productVariantId: string
}

export const GET_MARKETPLACE_SAVED_DEVICES = parse(`
  query GetMarketplaceSavedDevices {
    savedDevices {
      id
      companyId
      productVariantId
    }
  }
`)

export const SAVE_MARKETPLACE_DEVICE = parse(`
  mutation SaveMarketplaceDevice($productVariantId: String!) {
    saveDevice(productVariantId: $productVariantId) {
      id
      companyId
      productVariantId
    }
  }
`)

export const DELETE_MARKETPLACE_DEVICE = parse(`
  mutation DeleteMarketplaceDevice($productVariantId: String!) {
    deleteDevice(productVariantId: $productVariantId)
  }
`)
